/**
 * Pre-compiled localized messages for FormActionBar component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../../utils/normalize-messages";

// Pre-compiled message functions
import formActionBarMessages_en from "./intl/en";
import formActionBarMessages_de from "./intl/de";
import formActionBarMessages_es from "./intl/es";
import formActionBarMessages_fr from "./intl/fr-FR";
import formActionBarMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const formActionBarMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(formActionBarMessages_en),
  de: normalizeMessages(formActionBarMessages_de),
  es: normalizeMessages(formActionBarMessages_es),
  "fr-FR": normalizeMessages(formActionBarMessages_fr),
  "pt-BR": normalizeMessages(formActionBarMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for FormActionBar component
 */
export type FormActionBarMessageKey =
  | "ariaLabel"
  | "cancel"
  | "delete"
  | "save";
